import api from "../client.ts";

type RoleType = {
  id: number;
  name: string;
  status: number;
  created_at: string;   // or Date if you plan to parse it
  updated_at: string | null;
};

const getAll = async ():Promise<{size:number, data: RoleType[]}> => {
  const { data } = await api.get("/role/readAll");
  return data;
};

export const roleController = {getAll};
export type {RoleType};